import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { courseList } from "../../api/Courses";
import Master from "./Master";
import { batchList } from "../../api/Batch";
import { studentAttendanceListMonthly, studentAttendanceListMonthlyV4 } from "../../api/Attendance";
import { formatToDate, formatToTime } from "../master/FormatToDateTime";
import { printElement } from "../master/Print";
import { StaffList } from "../../api/Staff";

export default function StudentAttendancesMonthly() {
  const [loading, setLoading] = useState("");
  const [data, setData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [filters, setFilters] = useState({
    month: new Date().toISOString().split("T")[0].slice(0, 7),
  });
  const [year, month] = filters.month.split("-");

  const totalDays = new Date(year, month, 0).getDate();
  const today = formatToDate(new Date().toISOString().split("T")[0]);

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) return prev;
      return {
        ...prev,
        session_id: activeSession,
      };
    });
  }, [sessions]);

  const getCourse = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getStaffs = async () => {
    setLoading(true);
    try {
      const response = await StaffList(`status=1`);
      if (response.data.status) {
        setStaffs(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatches = async () => {
    setLoading(true);
    try {
      let addUrl = ``;
      if (filters?.session_id) {
        addUrl += `&session_id=${filters?.session_id}`;
      }
      if (filters?.course_id) {
        addUrl += `&course_id=${filters?.course_id}`;
      }
      const response = await batchList(addUrl);
      if (response.data.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.response?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getAttendanceList = async () => {
    if (!filters?.batch_id && !filters?.course_id && !filters?.staff_id) {
      return null;
    }
    setLoading(true);
    let addUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    try {
      const response = await studentAttendanceListMonthlyV4(addUrl);
      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.response?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAttendanceList();
  }, [filters]);

  useEffect(() => {
    getBatches();
  }, [filters?.course_id]);

  useEffect(() => {
    getCourse();
    getStaffs();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row g-2 align-items-center">
                          <div className="col-sm-6">
                            <h4 className="text-primary m-0">
                              Student Attendance List Monthly
                            </h4>
                          </div>
                          <div className="col-sm-6 text-end"></div>
                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="session"
                                value={filters?.session_id}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    session_id: e.target.value,
                                  })
                                }
                              >
                                {sessions?.map((session) => (
                                  <option key={session?.id} value={session?.id}>
                                    {session?.session} :{" "}
                                    {session?.status === "1"
                                      ? "Active"
                                      : " Inactive"}
                                  </option>
                                ))}
                              </select>

                              <label>Session</label>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select form-control"
                                name="course_id"
                                value={filters?.course_id}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    course_id: e.target.value,
                                  });
                                }}
                              >
                                <option value="">All</option>
                                {courses?.map((course, index) => (
                                  <option key={index} value={course.id}>
                                    {course.title}
                                  </option>
                                ))}
                              </select>
                              <label className="ms-5">Course</label>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select form-control"
                                name="batch_id"
                                value={filters?.batch_id}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    batch_id: e.target.value,
                                  });
                                }}
                              >
                                <option value="">All</option>
                                {batches?.map((batch, index) => (
                                  <option key={index} value={batch.id}>
                                    {batch.title}
                                  </option>
                                ))}
                              </select>
                              <label className="ms-5">Batch</label>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select form-control"
                                name="student_type"
                                value={filters?.student_type || ""}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    student_type: e.target.value,
                                  });
                                }}
                              >
                                <option value="">All Students</option>
                                <option value="hostel">Hostel Students</option>
                              </select>
                              <label className="ms-5">Student Type</label>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select form-control"
                                name="staff_id"
                                value={filters?.staff_id}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    staff_id: e.target.value,
                                  });
                                }}
                              >
                                <option value="">All</option>
                                {staffs?.map((staff, index) => (
                                  <option key={index} value={staff.id}>
                                    {staff.name} ({staff.registration_no})
                                  </option>
                                ))}
                              </select>
                              <label className="ms-5">Class Teacher</label>
                            </div>
                          </div>

                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="month"
                                className="form-control"
                                value={filters?.month}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    month: e.target.value,
                                  })
                                }
                              />
                              <label>Month</label>
                            </div>
                          </div>
                          <div className="col-1">
                            <button
                              className="btn btn-outline-danger"
                              onClick={() => printElement("PrintDiv", "", 0.6)}
                            >
                              <i className="ri-printer-line"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card mt-4">
                      <div className="card-body" id="PrintDiv">
                        <div className="row align-items-center justify-content-between">
                          <div className="col-7 text-center ">
                            <h5 className="mb-0 text-primary text-nowrap fw-bold">
                              {filters?.month
                                ? new Date(filters.month).toLocaleString(
                                  "default",
                                  {
                                    month: "long",
                                    year: "numeric",
                                  },
                                )
                                : ""}{" "}
                              Attendance{" "}
                              {filters?.batch_id && (
                                <>
                                  for{" "}
                                  {(() => {
                                    const batch = batches?.find(
                                      (b) =>
                                        Number(b.id) ===
                                        Number(filters.batch_id),
                                    );

                                    return (
                                      <>
                                        {batch?.title} - {batch?.course?.title}
                                      </>
                                    );
                                  })()}
                                </>
                              )}
                            </h5>
                          </div>
                          <div className="col-5 text-end ">
                            <small className="m-0 d-block">H : HolyDay</small>
                            <small className="m-0 d-block">
                              NA : Not Admitted
                            </small>
                            <small className="m-0 d-block">
                              N : Not Marked
                            </small>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover table-bordered  text-center">
                            <thead>
                              <tr className="text-nowrap">
                                <th className="p-1">#</th>
                                <th className="p-1">
                                  <b className="text-nowrap d-block m-0">
                                    Name
                                  </b>
                                  <small className="text-muted m-0">
                                    Gender
                                  </small>
                                </th>
                                <th className="p-1">
                                  <b className="text-nowrap d-block m-0">
                                    Mobile
                                  </b>
                                  <small className="m-0">Reg No</small>
                                </th>
                                {Array.from({ length: totalDays }, (_, i) => (
                                  <th className="p-1" key={i}>
                                    {i + 1}
                                  </th>
                                ))}
                                <th className="p-1">Overview</th>
                                <th className="p-1">Average</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.data?.map((item, index) => {
                                const admissionDate = formatToDate(
                                  item?.created_at ??
                                  item?.latest_course_and_fee?.created_at,
                                );
                                let totalPresent = 0;
                                let totalAbsent = 0;
                                let totalWorkingDays = 0;
                                let totalNotMarks = 0;

                                return (
                                  <tr key={item.id}>
                                    <td className="p-1">{index + 1}</td>
                                    <td className="p-1">
                                      <b className="text-nowrap d-block">
                                        {item?.name}
                                      </b>
                                      <small className="text-muted">
                                        {item?.gender}
                                      </small>
                                    </td>
                                    <td className="p-1">
                                      <b className="text-nowrap d-block m-0">
                                        {item?.phone}
                                      </b>
                                      <small className="m-0">
                                        {item?.registration_no}
                                      </small>
                                    </td>
                                    {Array.from(
                                      { length: totalDays },
                                      (_, i) => {
                                        const date = formatToDate(
                                          `${filters?.month}-${String(
                                            i + 1,
                                          ).padStart(2, "0")}`,
                                        );

                                        const isPastOrToday =
                                          new Date(date) <= new Date(today);

                                        const isAdmitted =
                                          new Date(date) >=
                                          new Date(admissionDate);

                                        const isHoliday =
                                          !data?.data?.some((student) =>
                                            student?.attendances?.some(
                                              (attendance) =>
                                                formatToDate(
                                                  attendance?.date,
                                                ) === date,
                                            ),
                                          ) && isPastOrToday;

                                        const leave = item?.applied_leave_request?.find(
                                          (l) => formatToDate(l?.date) === date
                                        );

                                        const hasLeave = !!leave;


                                        const attendance =
                                          item?.attendances?.find(
                                            (a) =>
                                              formatToDate(a?.date) === date,
                                          );
                                        if (
                                          !attendance &&
                                          isPastOrToday &&
                                          isAdmitted &&
                                          !isHoliday
                                        ) {
                                          totalNotMarks += 1;
                                        }

                                        if (
                                          isPastOrToday &&
                                          isAdmitted &&
                                          !isHoliday
                                        ) {
                                          totalWorkingDays += 1;
                                        }

                                        if (
                                          Number(attendance?.check_in) === 1
                                        ) {
                                          totalPresent += 1;
                                        }
                                        if (
                                          Number(attendance?.check_in) === 2
                                        ) {
                                          totalAbsent += 1;
                                        }

                                        return (
                                          <td className="p-1" key={i}>
                                            {Number(attendance?.check_in) ===
                                              1 ? (
                                              <div className="small">
                                                {attendance?.check_in_time ? (
                                                  <div
                                                    className="text-primary fw-bold text-nowrap"
                                                    style={{
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {formatToTime(
                                                      attendance?.check_in_time,
                                                    )}
                                                  </div>
                                                ) : (
                                                  <div className="text-primary fw-bold">
                                                    P{hasLeave && <span className="text-warning">/L</span>}
                                                  </div>
                                                )}

                                                {attendance?.check_out_time && (
                                                  <div
                                                    className="text-primary fw-bold text-nowrap"
                                                    style={{
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {formatToTime(
                                                      attendance?.check_out_time,
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            ) : Number(attendance?.check_in) ===
                                              2 ? (
                                              <b className="text-danger">A {hasLeave && <span className="text-warning">/L</span>}</b>
                                            ) : isHoliday ? (
                                              <b
                                                className="text-muted text-nowrap"
                                                title="Holiday"
                                              >
                                                H {hasLeave && <span className="text-warning">/L</span>}
                                              </b>
                                            ) : !isAdmitted ? (
                                              <small className="text-muted text-nowrap">
                                                NA {hasLeave && <span className="text-warning">/L</span>}
                                              </small>
                                            ) : !attendance && isPastOrToday ? (
                                              <small className="text-muted text-nowrap">
                                                N {hasLeave && <span className="text-warning">/L</span>}
                                              </small>
                                            ) : (
                                              ""
                                            )}
                                          </td>
                                        );
                                      },
                                    )}
                                    <td className="p-1">
                                      <div
                                        className="small text-primary text-nowrap"
                                        style={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        <span className="border-bottom fw-bolder">
                                          P : <b> {totalPresent}</b> | A :{" "}
                                          <b> {totalAbsent}</b> | N :{" "}
                                          <b> {totalNotMarks}</b>
                                        </span>
                                        <b className="d-block">
                                          {" "}
                                          {totalWorkingDays}
                                        </b>
                                      </div>
                                    </td>
                                    <td className="p-1">
                                      <b>
                                        {Math.floor(
                                          (totalPresent / totalWorkingDays) *
                                          100,
                                        )}
                                        %
                                      </b>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
